import { createContext } from "react";
import { localeText as defaultLocaleText } from "../../localeText.js";
const defaultState = {
  allowNoColor: false,
  allowRandomColor: true,
  autoCommit: false,
  color: "#fff",
  customColors: "none",
  goToAddColorToPalette: () => void 0,
  goToCustom: () => void 0,
  goToPalette: () => void 0,
  localeText: defaultLocaleText,
  maxRowsBeforeScrolling: 6,
  navigate: () => void 0,
  onAddColor: () => void 0,
  onCancel: () => void 0,
  onChange: () => void 0,
  onChangeSelection: () => void 0,
  onCommit: () => void 0,
  onDeleteColor: () => void 0,
  onDiscardLocalChanges: () => void 0,
  onInvalidColor: () => void 0,
  placeholderMode: "one-at-time",
  router: { route: { id: "palette" } },
  selection: /* @__PURE__ */ new Set(),
  swatchesGap: 1,
  swatchesPerRow: 8,
  swatchSize: 24,
  value: "#fff"
};
const colorPickerContext = createContext(defaultState);
export {
  colorPickerContext,
  defaultState
};
//# sourceMappingURL=context.js.map
